/**
 * Support Configuration Constants
 * Centralized configuration for support-related settings
 */

const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID || "vyua4cs5";

const FEEDBACK_FORM_URL =
  import.meta.env.VITE_FEEDBACK_FORM_URL || "https://tally.so/r/WO4pdJ";

export const SUPPORT_CONFIG = {
  // Support URLs
  helpUrl: "https://docs.ordering.co/docs/products/ai-dashboard/",

  // Intercom Configuration
  intercom: {
    appId: INTERCOM_APP_ID,
    enabled: !!INTERCOM_APP_ID,
    // Messenger API host (EU / regional workspaces); see Intercom install docs
    apiBase:
      import.meta.env.VITE_INTERCOM_API_BASE || "https://api-iam.intercom.io",
  },

  feedbackUrl: FEEDBACK_FORM_URL,

  // Support Options
  supportOptions: [
    {
      id: "help-center",
      title: "Help Center",
      titleKey: "support.options.helpCenter.title",
      description: "Browse documentation and guides",
      descriptionKey: "support.options.helpCenter.description",
      icon: "BookOpen",
      action: "external",
      url: "https://docs.ordering.co/docs/products/ai-dashboard/",
    },
    {
      id: "messages-tickets",
      title: "Messages & Tickets",
      titleKey: "support.options.messagesTickets.title",
      description: "Send messages and create support tickets",
      descriptionKey: "support.options.messagesTickets.description",
      icon: "MessageCircle",
      action: "intercom",
    },
    {
      id: "feature-requests",
      title: "Feature Requests & Feedback",
      titleKey: "support.options.featureRequests.title",
      description:
        "Share your ideas, report issues, and help us improve Ordering.co.",
      descriptionKey: "support.options.featureRequests.description",
      icon: "Lightbulb",
      action: "feedback",
      url: FEEDBACK_FORM_URL,
    },
  ],
};

export default SUPPORT_CONFIG;
